<template>
  <textarea 
    rows="3" 
    class="textarea-item" 
    :class="{'disabled': readonly}" 
    placeholder="请输入"
    v-model="itemValue"
    @input="onValueChange()"
  ></textarea>
</template>

<script>

export default {
  props: {
    item: Object,
    submitValue: Object,
    readonly: Boolean
  },
  emits: ['change'],
  data() {
    return {
      itemValue: null
    };
  },
  computed: {

  },
  components: {
  },
  methods: {
    // 【1】itemValue值设置
    setItemValue() {
      this.itemValue = this.submitValue?.value || '';
    },
    // 【2】值监听
    onValueChange() {
      this.$emit('change', {
        value: this.itemValue
      });
    }
  },
  created() {
    this.setItemValue();
  },
  async mounted() {
    
  },
};
</script>

<style lang="less" scoped>
@import (reference) '@/assets/less/common.less';

.textarea-item {
  .textarea-item();
}
</style>
